import axios from 'axios'
// import { notification } from 'antd'
// import { tokenId } from '../firebase'

const apiClient = axios.create({
  //baseURL: 'http://127.0.0.1:5001/growthlogic-benchmarking/us-central1',
  baseURL: 'https://us-central1-growthlogic-benchmarking.cloudfunctions.net'
})

apiClient.interceptors.request.use(async request => {
  /*const accessToken = await tokenId()
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }*/
  return request
})

apiClient.interceptors.response.use(undefined, error => {
  // Errors handling
  const { response } = error
  const { data } = response
  if (data) {
    console.log(data)
    /*
    notification.warning({
      message: data,
    })
    */
  }
})

export default apiClient
